module.exports = __webpack_public_path__ + "static/instagram-custom-a2cc66a1ed89ff057a0487264f7a2bfd.png";